export const isOnline = () => {
	if (localStorage.getItem('MOCK_OFFLINE')) {
		return false;
	}

	return fetch(`${import.meta.env.VITE_HOSTS_EVENT_DATA}/e3-health-check?t=${Date.now()}`)
		.then(res => res.ok)
		.catch(e => {
			console.error(e);
			return false;
		});
};